/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import type { UserPreferences } from '../@types';

export default class UserPreferencesModel {
	static userPreferences: {
		onboardingState?: string;
		genAIOptIn?: boolean;
	} = {};

	static storeUserPreferences(userPreferences: UserPreferences) {
		UserPreferencesModel.userPreferences = userPreferences;
	}
	static getUserPreferencs(): UserPreferences {
		return UserPreferencesModel.userPreferences;
	}
	static setGenAIPreference(genAIOptIn: boolean) {
		UserPreferencesModel.userPreferences.genAIOptIn = genAIOptIn;
	}
	static getGenAIPreference(): boolean {
		return UserPreferencesModel.userPreferences?.genAIOptIn;
	}
}
